package com.vizio.redwolf.pay.api

import com.vizio.redwolf.pay.client.CustomerSupportHttpClient
import com.vizio.redwolf.pay.model.Asset
import com.vizio.redwolf.pay.model.CreateSupportCaseRequest
import com.vizio.redwolf.pay.model.CreateSupportCaseResponse
import com.vizio.redwolf.pay.model.CustomerSupportResult
import com.vizio.redwolf.pay.model.FirmwareVersionResponse
import com.vizio.redwolf.pay.model.SerialNumberRequest
import com.vizio.redwolf.pay.model.SerialNumberResponse
import com.vizio.redwolf.pay.model.SupportHoursResponse
import com.vizio.redwolf.pay.model.handleCustomerSupportHttpResult
import com.vizio.redwolf.utils.AppConfig
import com.vizio.redwolf.utils.ClientConfig
import com.vizio.redwolf.utils.ECommerceEnvironmentConfig
import com.vizio.redwolf.utils.HttpResult
import com.vizio.redwolf.utils.PayEnvironment
import com.vizio.redwolf.utils.choosePayEnvironment
import com.vizio.redwolf.utils.clientprovider.ClientConfigFactory
import com.vizio.redwolf.utils.clientprovider.WebApiUseCase
import com.vizio.redwolf.utils.model.MobileHeaderInfo
import com.vizio.redwolf.utils.retryRequest
import io.ktor.client.statement.HttpResponse

class CustomerSupportApiImpl(
    payEnv: PayEnvironment,
    private val appConfig: AppConfig,
    private val clientConfig: ClientConfig = ClientConfigFactory.getClientConfig(WebApiUseCase.COOKIE_SDK_HEADERS)
) : CustomerSupportApi {

    private val customerSupportHttpClient = CustomerSupportHttpClient(payEnv = payEnv, appConfig = appConfig, clientConfig = clientConfig)

    constructor(envConfig: ECommerceEnvironmentConfig, appConfig: AppConfig) : this(choosePayEnvironment(envConfig), appConfig, ClientConfigFactory.getClientConfig(WebApiUseCase.COOKIE_SDK_HEADERS))
    constructor(envConfig: ECommerceEnvironmentConfig, appConfig: AppConfig, clientConfig: ClientConfig) : this(choosePayEnvironment(envConfig), appConfig, clientConfig)
    constructor(envConfig: ECommerceEnvironmentConfig, appConfig: AppConfig, timeout: Long) : this(choosePayEnvironment(envConfig), appConfig, ClientConfigFactory.getClientConfig(WebApiUseCase.COOKIE_SDK_HEADERS, timeout))

    companion object {
        const val ERROR_CONTENT_TYPE_NOT_SUPPORTED = "NoTransformationFoundException: Response ContentType is not supported"
    }

    override suspend fun validateSerialNumber(serialNumberRequest: SerialNumberRequest): CustomerSupportResult<SerialNumberResponse> {
        return getRequestResultWithRetry { customerSupportHttpClient.validateSerialNumber(serialNumberRequest) }
    }

    override suspend fun getProductAssets(id: String): CustomerSupportResult<List<Asset>> {
        return getRequestResultWithRetry { customerSupportHttpClient.getProductAssets(id) }
    }

    override suspend fun getSupportHours(): CustomerSupportResult<SupportHoursResponse> {
        return getRequestResultWithRetry { customerSupportHttpClient.getSupportHours() }
    }

    override suspend fun getProductFirmwareVersion(serialNumber: String): CustomerSupportResult<FirmwareVersionResponse> {
        return getRequestResultWithRetry { customerSupportHttpClient.getProductFirmwareVersion(serialNumber) }
    }

    override suspend fun createSupportCase(createSupportCaseRequest: CreateSupportCaseRequest, mobileHeaderInfo: MobileHeaderInfo?): CustomerSupportResult<CreateSupportCaseResponse> {
        return getRequestResultWithRetry { customerSupportHttpClient.createSupportCase(createSupportCaseRequest, mobileHeaderInfo) }
    }

    private suspend inline fun <reified T : Any> getRequestResultWithRetry(callBlock: () -> HttpResult<HttpResponse>): CustomerSupportResult<T> {
        return retryRequest(clientConfig, { handleCustomerSupportHttpResult(callBlock()) },
                            isSuccess = { result -> result is CustomerSupportResult.Success<*> })
    }
}